import { useEffect, useState } from 'react';
import Typography from '@mui/material/Typography';
import { useAuth } from '@/common/hooks/useAuth';

function WelcomeName() {
  const auth = useAuth();
  const [name, setName] = useState('');

  useEffect(() => {
    if (auth.user.name) {
      setName(auth.user.name);
    } else {
      setName('');
    }
  }, [auth.user.name]);

  if (name) {
    return (
      <Typography variant="h6" align="right" sx={{ display: { xs: 'none', md: 'flex' } }}>
        ようこそ、{name}さん
      </Typography>
    );
  }
  return null;
}

export default WelcomeName;
